// extracted by mini-css-extract-plugin
export default {"svg_rotate":"universal_svg_rotate__eIZoG","rotate4":"universal_rotate4__qt4MX","dash4":"universal_dash4__TLWmo"};